export default {
  methods: {
    getImageOfSize(path, size) {
      try {
        const pathArray = path.split('.');
        let obj = this;
        for (let i = 0; i < pathArray.length; i++) {
          if (obj[pathArray[i]] === null || obj[pathArray[i]] === undefined) {
            return '';
          }
          obj = obj[pathArray[i]];
        }
        const image = obj.formats[size];
        return image ? image.url : '';
      } catch (e) {
        return '';
      }
    }
  }
}
